// NPM Imports
import React from "react";
import { Label, Input } from "../../../../revvComponents";

export default function RevvEditorRadio({
  fieldName,
  isDisabled,
  option,
  radioId,
  fieldValue,
  handleRadioField,
  className,
  isReadOnly,
  inputFieldStyles,
}) {
  let isChecked = fieldValue === option;
  if (
    fieldValue &&
    (fieldValue.startsWith("Other : ") || fieldValue.startsWith("Other ")) &&
    (option.startsWith("Other : ") || option.startsWith("Other "))
  ) {
    isChecked = true;
  }
  if (isReadOnly) {
    if (isChecked) {
      className += " checked ";
    }
  }

  return (
    <span className={className} contentEditable={false}>
      <Label htmlFor={radioId}>
        <Input
          key={`${radioId}-${isChecked ? "checked" : "unchecked"}`}
          id={radioId}
          name={fieldName}
          data-test={"revveditor-radio-input-field"}
          type={"radio"}
          checked={isChecked}
          onChange={() => handleRadioField(option)}
          disabled={isDisabled}
          value={option}
        />
        {option && (
          <span className="revveditor-checkbox-label" style={inputFieldStyles}>
            {option}
          </span>
        )}
      </Label>
    </span>
  );
}
